import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './style/global.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility);

Vue.use(ElementUI);

Vue.prototype.isMobile = document.documentElement.clientWidth <= 0

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  
  mounted () {
      document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js